<div class="row login-box">
  <div class="col-7 login-backgroud">
    <div class="row" style="height: 85%;">
      <div class="col-6"></div>

      <div class="col-6 login-form align-self-center">
        <div [formGroup]="form">
          <div class="row">
            <div class="col-12 text-center">
              <label class="font-cust-blue" style="font-size: 3.2rem !important; font-weight: bolder !important;">DPA
                CRM</label>
            </div>
          </div>
          <div class="row">
            <div class="input-group">
              <label for="username"><span class="fa fa-lg fa-user font-cust-blue"></span></label>
              <input type="text" class="form-control ml-3" name="username" placeholder="Username"
                formControlName="username">
            </div>
            <span class="text-danger ml-5"
              *ngIf="(formControl.username.touched || submitted) && formControl.username.errors?.required">
              กรุณาระบุ Username
            </span>
          </div>
          <div class="row mt-3 mb-3">
            <div class="input-group">
              <label for="password"><span class="fa fa-lg fa-key font-cust-blue"></span></label>
              <input type="password" class="form-control ml-3" name="Password" placeholder="Password"
                formControlName="password">
            </div>
            <span class="text-danger ml-5"
              *ngIf="(formControl.password.touched || submitted) && formControl.password.errors?.required">
              กรุณาระบุ Password
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-center">
            <button class="btn btn-primary mr-2" (click)="Login()">Login</button>
            <button class="btn btn-primary ml-2" (click)="clear()">Clear</button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 text-center">
            <button class="btn btn-link w-80" (click)="resetPassword()">ลืมรหัสผ่าน ?</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.html